// extracted by mini-css-extract-plugin
export default {"wrapper":"M_QRCodeContainer_wrapper__JwLEr","text":"M_QRCodeContainer_text__7qEiM","buttons_wrapper":"M_QRCodeContainer_buttons_wrapper__zk0yQ"};